'use client';
import { FC, useEffect, useState } from 'react';
import styles from './BookingInfo.module.scss';
import Image from 'next/image';
import Clock from '../../app/assets/icons/clock-2.svg';
import Globus from '../../app/assets/icons/globus.svg';
import Hand from '../../app/assets/icons/hand.svg';
import Chat from '../../app/assets/icons/chat.svg';
import Location from '../../app/assets/icons/location-2.svg';

import { SingleEventInfo } from '@/models/EventModels';
import { format } from 'date-fns';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import { uk, enGB } from 'date-fns/locale';
import UrlResolverComponent from "@/shared/UrlResolverComponent/UrlResolverComponent";

interface BookingInfoProps {
  className?: string;
  event?: SingleEventInfo;
}

const BookingInfo: FC<BookingInfoProps> = ({ className = '', event }) => {
  const t = useTranslations('BOOKING_BLOCK');

  const locale = useLocale();

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.location}>
        <div className={styles.location__column}>
          <Image src={Clock} alt="clock" />
          <div className={styles.location__texts}>
            <p>{t('start')}</p>
            <span>{format(
              new Date(event?.start || ''),
              locale === 'ua' ? 'dd MMMM, HH:mm ' : 'MMMM dd, hh:mm a',
              {locale: locale === 'ua' ? uk : enGB,})}
            </span>
          </div>
        </div>
        <div className={styles.location__column}>
          <Image src={Location} alt="Location" />
          <div className={styles.location__texts}>
            <p>{t('address')}</p>
            <address>{event?.address}</address>
          </div>
        </div>
      </div>

      {/*<p className={styles.gmt}>{t('language')} (GMT+3)</p>*/}

      <div className={styles.description}>
        <div className={styles.description__item}>
          <Image src={Globus} alt="clock" />
          <p>{t('language')}: </p>
          <b>{t('languages.uk')}</b>
        </div>

        {/*<div className={styles.description__item}>*/}
        {/*  <Image src={Hand} alt="hand" />*/}
        {/*  <p>{t('restrictions')}: </p>*/}
        {/*  <b>16+</b>*/}
        {/*</div>*/}

        <div className={styles.description__item}>
          <Image src={Chat} alt="Chat" />
          <p>{t('contacts')}: </p>
          <UrlResolverComponent
            text={event?.contacts || ''} />
        </div>
      </div>

      <UrlResolverComponent className={styles.root__description} text={event?.description || ''}/>
    </div>
  );
};

export default BookingInfo;
